import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { scheduleAdsVisit } from "./lib/trafficTracking";

function loadAnalyticsScript() {
	const analyticsEndpoint = String(import.meta.env.VITE_ANALYTICS_ENDPOINT || "").trim();
	const analyticsWebsiteId = String(import.meta.env.VITE_ANALYTICS_WEBSITE_ID || "").trim();

	if (!analyticsEndpoint || !analyticsWebsiteId) {
		return;
	}

	const normalizedSrc = `${analyticsEndpoint.replace(/\/+$/, "")}/umami`;
	const existingScript = document.querySelector(
		`script[src="${normalizedSrc}"][data-website-id="${analyticsWebsiteId}"]`
	);

	if (existingScript) {
		return;
	}

	const script = document.createElement("script");
	script.defer = true;
	script.src = normalizedSrc;
	script.setAttribute("data-website-id", analyticsWebsiteId);
	document.body.appendChild(script);
}

loadAnalyticsScript();

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
scheduleAdsVisit();
